:host {
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: inherit;
}

@media screen and (max-width: 979px) {
  :host {
    padding-top: 6px;
  }
}

.runtime-field__row {
  display: flex;
  align-items: center;
}

.runtime-field__row + .runtime-field__row {
  margin-top: 6px;
}

.runtime-field__label {
  color: inherit;
}

:host(:not([dir="rtl"])) .runtime-field__label {
  margin-right: 8px;
}

:host([dir="rtl"]) .runtime-field__label {
  margin-left: 8px;
}

.runtime-field__input {
  box-sizing: border-box;
  color: #333333;
  font-size: 1rem;
  line-height: inherit;
  height: 30px;
  width: 58px;
  padding: 0 8px;
  font-weight: normal;
  border: 1px solid #cbcbcb;
  outline: none;
}

.runtime-field__input *,
.runtime-field__input *::before,
.runtime-field__input *::after {
  box-sizing: inherit;
}

.runtime-field__input:focus, .runtime-field__input:active {
  border-color: #333333;
}

.runtime-field__input--error {
  border-color: #b10043;
}

.runtime-field__measure {
  color: #333333;
  font-weight: normal;
}

:host(:not([dir="rtl"])) .runtime-field__measure {
  margin-left: 4px;
}

:host([dir="rtl"]) .runtime-field__measure {
  margin-right: 4px;
}

.runtime-field__load-range {
  display: flex;
  align-items: center;
  font-weight: normal;
  color: #9fa0a4;
}

@media screen and (max-width: 979px) {
  .runtime-field__load-range {
    padding-top: 2px;
  }
}